// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";
const PlayCircle: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="144" height="144" viewBox="0 0 144 144">
            <g fill="none" fillRule="evenodd" transform="translate(10 10)">
                <circle cx="62" cy="62" r="67" fill="#DF1E27" stroke="#FFF" stroke-opacity=".3" stroke-width="10" />
                <path
                    fill="#FFF"
                    fillRule="nonzero"
                    d="M81.2539077,57.8711896 C82.6503909,58.7305648 83.5,60.2442367 83.5,61.8750958 C83.5,63.5059564 82.6503909,65.0196282 81.2539077,65.791112 L53.1318373,82.978612 C51.684571,83.9454083 49.8730472,83.9844702 48.3945317,83.1543921 C46.9157225,82.324314 46,80.761814 46,79.0625958 L46,44.6875958 C46,42.9922847 46.9157225,41.4288072 48.3945317,40.5987291 C49.8730472,39.7696285 51.684571,39.8038058 53.1318373,40.6875966 L81.2539077,57.8711896 Z"
                />
            </g>
        </svg>
    );
};
export default React.memo(PlayCircle);
